// extracted by mini-css-extract-plugin
export default {"actions":"MSm99U3KjrHSA7Q4779r","hasLink":"XWOpTOKWHc1B0XEVG9cL","ellipsis":"S86f8QuYMXbyv0zKUj9N"};